import {store} from '../../../redux/store';
import {services} from '../../../api';
import {
  finishLoading,
  startLoading,
} from '../../../connected-components/loading/actions';
import {showGlobalToast} from '../../../connected-components/toast/actions';
import {tr} from '../../../translation';
import {DashboardLoginForm} from '../../../interfaces/api/dashboard/login';
import {LoginDataType} from '../../../interfaces/api/auth/login';
import {flushLocalData, setLocalData} from '../../../utils/storage';
import {keys} from '../../../api/keys';
import {login, logout} from './reducer';

/**
 * this function to log in to dashboard
 */
export const dashboardLogIn = async (
  body: DashboardLoginForm,
): Promise<{success: boolean; message?: string}> => {
  try {
    startLoading();
    const {currentUser} = store.getState().auth || {};
    const res = await services.auth.dashboardLogin(body);
    if (res?.code !== 200) {
      throw new Error('');
    }
    await startSession({
      ...currentUser,
      dashboardToken: res?.data?.access_token,
      role: res?.data?.role,
    });
    showGlobalToast({
      message: tr('login.loginSuccessMessage') + body?.username,
      type: 'success',
    });
    return {success: true};
  } catch (error: any) {
    if (process.env.REACT_APP_DEBUG === 'true') {
      console.info('DASHBOARD LOGIN FAIL: ', error);
    }

    const message = error.response?.data?.error?.message
      ? error.response?.data?.error?.message
      : tr('login.loginFailMessage');
    return {success: false, message};
  } finally {
    finishLoading();
  }
};

export const startSession = async (user: LoginDataType) => {
  try {
    const currentUser = {...user};
    await setLocalData(keys.CURRENT_USER, currentUser);
    store.dispatch(login(currentUser));
    return true;
  } catch (error) {
    if (process.env.REACT_APP_DEBUG === 'true') {
      console.info('LOGIN FAIL: ', error);
    }
    return false;
  }
};

/**
 * clear user session.
 *
 * @returns {Promise<boolean>} - A promise that resolves to `true` if logout is successful, otherwise `false`.
 */
export const endSession = async () => {
  try {
    startLoading();
    const {currentUser} = store.getState().auth || {};
    if (currentUser?.token)
      showGlobalToast({
        message: tr('login.logoutSuccessfully'),
        type: 'success',
      });
    store.dispatch(logout());
    await flushLocalData();
    return true;
  } catch (error) {
    if (process.env.REACT_APP_DEBUG === 'true') {
      console.info('LOGOUT FAIL: ', error);
    }
    return false;
  } finally {
    finishLoading();
  }
};
